/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Card_DataInputs */



/**
* | output |
* | --- |
* | "Card data" |
*
* @param {Layout_Header_Card_DataInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_card_data = /** @type {((inputs?: Layout_Header_Card_DataInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Card_DataInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kartendaten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Données de carte")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡牌数据")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡牌資料")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드 데이터")
	return /** @type {LocalizedString} */ ("Card data")
});